import { createSelector } from '@reduxjs/toolkit';

import { createMappingByKey } from '@paragon/production-app-utilities';

import { RootState } from '../slices';

export const getBatchesByProductionGroupGuid = createSelector(
  (state: RootState) => state.batches,
  (state: RootState) => state.productionGroups,

  (batches, productionGroups) => createMappingByKey(batches, (batch) => batch.productionGroupGuid, productionGroups),
);
